import React, { useState } from "react";
import { Button, Col, Modal, ProgressBar, Row } from "react-bootstrap";

const Dialogue = ({ show, onHide }) => {
    const [dialogue, setDialogue] = useState(false);
    const [sceance, setSceance] = useState([
        {
            id: 1,
            name: "Echauffement",
            image: "path/to/image1.jpg",
            description: "3 minutes de préparation pour réchauffer les muscles",
            exercises: [
                { 
                    name: "Jumping Jacks", 
                    duration: "1 min", 
                    gif: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnd3anc5a21oeDA5cndycmc0cHE5MjI5ZGt2aW50amY3ZHpzajZ4eCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ckMk3RKUK29lziaspI/giphy.webp", 
                    description: "Un exercice de cardio pour échauffer tout le corps.",
                    tips: [
                        "Gardez le dos droit.",
                        "Sautez avec les pieds écartés à la largeur des épaules.",
                        "Levez les bras au-dessus de la tête."
                    ]
                },
                { 
                    name: "High Knees", 
                    duration: "1 min", 
                    gif: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnd3anc5a21oeDA5cndycmc0cHE5MjI5ZGt2aW50amY3ZHpzajZ4eCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ckMk3RKUK29lziaspI/giphy.webp", 
                    description: "Un exercice pour augmenter le rythme cardiaque et échauffer les jambes.",
                    tips: [
                        "Levez les genoux aussi haut que possible.",
                        "Gardez un rythme rapide.",
                        "Utilisez vos bras pour maintenir l'équilibre."
                    ]
                },
                { 
                    name: "Arm Circles", 
                    duration: "1 min", 
                    gif: "path/to/arm_circles.gif", 
                    description: "Un exercice pour échauffer les épaules et les bras.",
                    tips: [
                        "Faites des cercles larges avec les bras.",
                        "Gardez les bras tendus.",
                        "Changez de direction à mi-chemin."
                    ]
                }
            ]
        },
        {
            id: 2,
            name: "Nombre de répétitions",
            image: "path/to/image2.jpg",
            description: "20 minutes",
            exercises: [
                { 
                    name: "Push-ups", 
                    reps: "15", 
                    gif: "path/to/push_ups.gif", 
                    description: "Un exercice de renforcement pour les bras et la poitrine.",
                    tips: [
                        "Gardez le corps droit.",
                        "Descendez jusqu'à ce que votre poitrine touche presque le sol.",
                        "Gardez les coudes près du corps."
                    ]
                },
                { 
                    name: "Squats", 
                    reps: "20", 
                    gif: "path/to/squats.gif", 
                    description: "Un exercice pour renforcer les jambes et les fessiers.",
                    tips: [
                        "Gardez le dos droit.",
                        "Descendez jusqu'à ce que vos cuisses soient parallèles au sol.",
                        "Gardez les genoux alignés avec les orteils."
                    ]
                },
                { 
                    name: "Lunges", 
                    reps: "15 each leg", 
                    gif: "path/to/lunges.gif", 
                    description: "Un exercice pour travailler l'équilibre et renforcer les jambes.",
                    tips: [
                        "Faites un grand pas en avant.",
                        "Gardez le genou avant aligné avec la cheville.",
                        "Gardez le dos droit."
                    ]
                }
            ]
        },
        {
            id: 3,
            name: "Repos",
            image: "path/to/image3.jpg",
            description: "finir la séance par de la relaxation",
            exercises: [
                { 
                    name: "Deep Breathing", 
                    duration: "5 min", 
                    gif: "https://media.giphy.com/media/xT8qBff8cRRFf7k2u4/giphy.gif", 
                    description: "Un exercice de relaxation pour calmer l'esprit et le corps.",
                    tips: [
                        "Inspirez profondément par le nez.",
                        "Expirez lentement par la bouche.",
                        "Concentrez-vous sur votre respiration."
                    ]
                },
                { 
                    name: "Stretching", 
                    duration: "5 min", 
                    gif: "path/to/stretching.gif", 
                    description: "Un exercice pour détendre les muscles après l'entraînement.",
                    tips: [
                        "Étirez chaque muscle lentement.",
                        "Ne forcez pas l'étirement.",
                        "Respirez profondément pendant l'étirement."
                    ]
                }
            ]
        }
    ]);

    const [currentSeanceIndex, setCurrentSeanceIndex] = useState(0);
    const [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);

    const currentSeance = sceance[currentSeanceIndex];
    const currentExercise = currentSeance.exercises[currentExerciseIndex];

    const handleNext = () => {
        setDialogue(true);
        if (currentExerciseIndex < currentSeance.exercises.length - 1) {
            setCurrentExerciseIndex(currentExerciseIndex + 1);
        } else if (currentSeanceIndex < sceance.length - 1) {
            setCurrentSeanceIndex(currentSeanceIndex + 1);
            setCurrentExerciseIndex(0);
        }
    };

    const handlePrevious = () => {
        if (currentExerciseIndex > 0) {
            setCurrentExerciseIndex(currentExerciseIndex - 1);
        } else if (currentSeanceIndex > 0) {
            const previousSeanceIndex = currentSeanceIndex - 1;
            setCurrentSeanceIndex(previousSeanceIndex);
            setCurrentExerciseIndex(sceance[previousSeanceIndex].exercises.length - 1);
        }
    };

    return (
        <Modal show={show} fullscreen={true} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h1 className="text-center mb-0 pe-5">Plan d'entraînement</h1>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Row>
              
             

                <Col md={12} className="bg-light rounded p-4">
                    <ProgressBar now={(currentExerciseIndex + 1) / currentSeance.exercises.length * 100} className="mb-3" />
                    <div>
                        <h3>{currentExercise.name}</h3>
                        <p>{currentExercise.description}</p>
                        <Row>
                            <Col md={6}>
                                <img
                                    className="d-block w-100 mb-3 rounded"
                                    src={currentExercise.gif}
                                    alt={currentExercise.name}
                                    style={{ height: '300px',width: '100%', objectFit: 'contain' }} 
                                />
                            </Col>
                            <Col md={6}>
                                <ul>
                                    {currentExercise.tips.map((tip, index) => (
                                        <li key={index}>{tip}</li>
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                        <Button variant="secondary" onClick={handlePrevious} disabled={currentSeanceIndex === 0 && currentExerciseIndex === 0}>
                            Précédent
                        </Button>
                        <Button variant="primary" onClick={handleNext} disabled={currentSeanceIndex === sceance.length - 1 && currentExerciseIndex === currentSeance.exercises.length - 1}>
                            Suivant
                        </Button>
                    </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default Dialogue;